export interface I2DImgTryonProps {
    tooHigh: boolean;
    notEyeImgTooHigh: boolean; // 好像是需要用户手动裁剪的图片是高还是矮
    lt: any; // 如果用户上传的图片太高或者太宽，需要有偏移量来让图片显示正常。已经用不到了，第一版2d试戴，没有裁剪功能，所以使用了一个变量来调整眼睛图的位置
    imgList: any; // 2d试戴下边图片列表
    currImg: any; // 当前戴眼镜的图片 类型:USER_PHOTO
    notAllowUploadVisible: boolean; // 是否展示不能上传图片的modal
    firstNotice: boolean; // 是否展示使用提示，第一次使用才展示
    pdModalVisible: boolean; // 控制移动端选择pd的modal的显示
    glassesImgSrc: string; // 戴的眼镜图移除四周透明像素转成base64
    glassesColorImgSrc: string; // 戴的眼镜染色片图移除四周透明像素转成base64
    glassesSize: any; // 戴的眼镜图移除四周透明像素后的宽高
    selectPd: any; // 用户在选择pd的modal中选择的pd
    usrPd: any; // 给图片戴眼镜时使用的pd
    usrConfirmImg: any; // 需要用户确定瞳孔位置的图片转成dataUrl
    style: any; // 最终戴在图片上的眼睛的样式（宽、高、rotate等）
    lPosition: any; // 用户手动确定的左瞳孔的位置
    rPosition: any; // 用户手动确定的右瞳孔的位置
    mouseLocation: string; // 记录用户鼠标的位置。在左瞳孔标记上，或者右瞳孔标记上，或者在其他敌方。用来在鼠标拖拽的时候更新lPosition或者rPosition
    loading: boolean; // 是否正在上传图片
    uploadError: boolean; // 上传失败提示是否显示
    imgLoading: boolean; // 展示一个loading动画，用在眼镜图片加载完成之前
    userUploadFile: any; // 用户选择的图片，将会被用来裁剪，由于第一版的功能没有裁剪，是直接上传，所以变量名是用户上传文件
    delBtnLoading: boolean; // 删除图片时展示一个loading动画
    noticeShow: boolean;
}

export type State = I2DImgTryonProps;

export type Action = {
    SET_SELECT_PD: (selectPd: any) => void;
    SET_USR_PD_H5: (pd: any) => void;
    SET_IMG_LIST: (payload: any) => void;
    SET_USR_CONFIRM_IMG_INFO: (payload: any) => void;
    SET_NOT_ALLOW_UPLOAD: (notAllowUploadVisible: boolean) => void;
    SET_FIRST_NOTICE: (firstNotice: boolean) => void;
    AFTER_SAVE_EYE_POSITION: (payload: any) => void;
    SHOW_IMG: (payload: any) => void;
    SET_L_POSITION: (lPosition: any) => void;
    SET_R_POSITION: (rPosition: any) => void;
    SET_GLASSES_INFO: (payload: any) => void;
    SET_GLASSES_COLOR_INFO: (payload: any) => void;
    SET_STYLE: (payload: any) => void;
    SET_PD_MODAL: (pdModalVisible: boolean) => void;
    SET_MOUSE_LOCATION: (mouseLocation: any) => void;
    SET_UPLOAD_ERROR: (uploadError: any) => void;
    SET_IMG_LOADING: (imgLoading: boolean) => void;
    SET_USR_UPLOAD_FILE: (userUploadFile: any) => void;
    SET_DEL_LOADING: (delBtnLoading: any) => void;
    SET_NOTICE_SHOW: (noticeShow: boolean) => void;
    SET_UPLOAD_LOADING: (loading: boolean) => void;
};

export type I2DImgTryonStateAndAction = State & Action;

// 默认pd
const defaultPd = "63";
import { modelImgEyeList } from "./modelImgEyeList";

export const initialState: State = {
    tooHigh: true, // 用户上传图片的高/宽 > 图片容器的高/宽。  图片需要按照一定的比例缩放，确定比例，需要知道图片是高还是矮
    notEyeImgTooHigh: true, // 好像是需要用户手动裁剪的图片是高还是矮
    lt: [0, 0], // 如果用户上传的图片太高或者太宽，需要有偏移量来让图片显示正常。已经用不到了，第一版2d试戴，没有裁剪功能，所以使用了一个变量来调整眼睛图的位置
    imgList: modelImgEyeList, // 2d试戴下边图片列表
    currImg: null, // 当前戴眼镜的图片 类型:USER_PHOTO
    notAllowUploadVisible: false, // 是否展示不能上传图片的modal
    firstNotice: false, // 是否展示使用提示，第一次使用才展示
    pdModalVisible: false, // 控制移动端选择pd的modal的显示
    glassesImgSrc: "", // 戴的眼镜图移除四周透明像素转成base64
    glassesColorImgSrc: "", // 戴的眼镜染色片图移除四周透明像素转成base64
    glassesSize: "", // 戴的眼镜图移除四周透明像素后的宽高
    selectPd: defaultPd, // 用户在选择pd的modal中选择的pd
    usrPd: defaultPd, // 给图片戴眼镜时使用的pd
    usrConfirmImg: "", // 需要用户确定瞳孔位置的图片转成dataUrl
    style: null, // 最终戴在图片上的眼睛的样式（宽、高、rotate等）
    lPosition: [140, 116], // 用户手动确定的左瞳孔的位置
    rPosition: [190, 116], // 用户手动确定的右瞳孔的位置
    mouseLocation: "", // 记录用户鼠标的位置。在左瞳孔标记上，或者右瞳孔标记上，或者在其他敌方。用来在鼠标拖拽的时候更新lPosition或者rPosition
    loading: false, // 是否正在上传图片
    uploadError: false, // 上传失败提示是否显示
    imgLoading: true, // 展示一个loading动画，用在眼镜图片加载完成之前
    userUploadFile: null, // 用户选择的图片，将会被用来裁剪，由于第一版的功能没有裁剪，是直接上传，所以变量名是用户上传文件
    delBtnLoading: false, // 删除图片时展示一个loading动画
    noticeShow: true,
};
